import { render, staticRenderFns } from "./ipv6Address.vue?vue&type=template&id=2bb84eac&"
import script from "./ipv6Address.vue?vue&type=script&lang=js&"
export * from "./ipv6Address.vue?vue&type=script&lang=js&"
import style0 from "./ipv6Address.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports